import ReactOnRails from 'react-on-rails';
import LandingPage from '../../entrypoints/LandingPage.jsx';

ReactOnRails.register({LandingPage});
